import IssuersList from "./Issuers/pages/IssuersList";
import AdvancedSecurities from "./SecurityTable/pages/AdvancedSecurities";


const GlobalSecurities = () => {

  return (
    <div>
      <div className="search-filter-container" style={{ marginTop: '-10px', marginBottom: '-10px'}}>
        <h2 className="card-title fw-bold text-primary-emphasis text-center text-uppercase fs-2" style={{ letterSpacing: "0.10em" }}>Listes des Emetteurs</h2>
      </div>
        <IssuersList/>
        {/* Section des titres publics */}
      <div className="search-filter-container" style={{ marginTop: '-10px', marginBottom: '-10px' }}>
        <h2 className="card-title mb-1 fw-bold text-center text-uppercase text-primary-emphasis fs-2" style={{ letterSpacing: "0.10em" }}>
          Listes des Titres
        </h2>
      </div>
        <AdvancedSecurities/>
    </div>
  );
};

export default GlobalSecurities;
